module.exports = __webpack_public_path__ + "img/titanium.567a63d2.svg";